import { IOrder } from "@/interfaces";

export const CanUserCancelOrder = (
  order: IOrder | null | undefined,
  userId: string | null | undefined,
) => {
  // can show cancel button if order type is sell and me is seller
  // or order type is buy and me is buyer
  if (order && userId && order.status === "OPEN") {
    if (order.order_type === "SELL") {
      return userId === order.seller_id;
    } else {
      return userId === order.buyer_id;
    }
  }
  return false;
};

export const CanOrderBeCancel = (order: IOrder | null | undefined) => {
  // can disable cancel button if order state is pending and time elapsed is less than 1 hour
  if (order) {
    if (order.status === "OPEN") {
      //convert created_at string to number
      const created_at = Date.parse(order.created_at);
      const timeElapsed = Date.now() - created_at;
      return timeElapsed < 3600000;
    }
  }
  return false;
};
